(() => {
  /* =====================================================
     INIT GUARD (per section)
     Avoids theme editor / section re-render issues.
     Safe: builder behavior stays the same.
  ===================================================== */
  window.__CHAOS_BUILDER_INIT__ = window.__CHAOS_BUILDER_INIT__ || {};

  const TOTAL = 11;

  const CLOUDINARY = {
    cloudName: "dpm7hs5vw",
    uploadPreset: "chaos-previews"
  };

  /* =========================
     IMAGE SOURCES
  ========================= */
  const IMG = {
    BASE_STANDARD:
      "https://cdn.shopify.com/s/files/1/0680/1460/4388/files/iphone_15_2.png?v=1771538919",

    BASE_PRO_13_14:
      "https://cdn.shopify.com/s/files/1/0680/1460/4388/files/YOUR_13_14_PRO_IMAGE.png?v=1",

    BASE_PRO_15_16:
      "https://cdn.shopify.com/s/files/1/0680/1460/4388/files/iphone_15_pro_max_2_efe32010-6572-4f4c-a964-09f0dd8ec4ba.png?v=1771538432",

    BASE_16_17_CORE:
      "https://cdn.shopify.com/s/files/1/0680/1460/4388/files/iphone_16_1.png?v=1771538660",

    BASE_17_PRO:
      "https://cdn.shopify.com/s/files/1/0680/1460/4388/files/iphone_17_pro_2_58fb0ec4-f999-442e-94f5-38c152775643.png?v=1771542047",

    BASE_11_PRO:
      "https://cdn.shopify.com/s/files/1/0680/1460/4388/files/YOUR_11_PRO_IMAGE.png?v=1",

    BASE_12_PRO:
      "https://cdn.shopify.com/s/files/1/0680/1460/4388/files/YOUR_12_PRO_IMAGE.png?v=1",
  };

  /* =========================
     MODEL → IMAGE MAP
  ========================= */
  const BASES = {
    /* Standard Models */
    "iPhone 15": IMG.BASE_STANDARD,
    "iPhone 15 Plus": IMG.BASE_STANDARD,
    "iPhone 14": IMG.BASE_STANDARD,
    "iPhone 14 Plus": IMG.BASE_STANDARD,
    "iPhone 13": IMG.BASE_STANDARD,
    "iPhone 13 Mini": IMG.BASE_STANDARD,
    "iPhone 11": IMG.BASE_STANDARD,
    "iPhone 12": IMG.BASE_STANDARD,
    "iPhone 12 Mini": IMG.BASE_STANDARD,

    /* 12 Pro Family */
    "iPhone 12 Pro": IMG.BASE_PRO_15_16,
    "iPhone 12 Pro Max": IMG.BASE_PRO_15_16,

    /* 13 / 14 Pro Family */
    "iPhone 14 Pro": IMG.BASE_PRO_15_16,
    "iPhone 14 Pro Max": IMG.BASE_PRO_15_16,
    "iPhone 13 Pro": IMG.BASE_PRO_15_16,
    "iPhone 13 Pro Max": IMG.BASE_PRO_15_16,

    /* 15 / 16 Pro Family */
    "iPhone 16 Pro": IMG.BASE_PRO_15_16,
    "iPhone 16 Pro Max": IMG.BASE_PRO_15_16,
    "iPhone 15 Pro": IMG.BASE_PRO_15_16,
    "iPhone 15 Pro Max": IMG.BASE_PRO_15_16,

    /* 16 / 17 Core Family */
    "iPhone 17": IMG.BASE_16_17_CORE,
    "iPhone 16": IMG.BASE_16_17_CORE,
    "iPhone 16 Plus": IMG.BASE_16_17_CORE,

    /* 11 Pro Family */
    "iPhone 11 Pro": IMG.BASE_PRO_15_16,
    "iPhone 11 Pro Max": IMG.BASE_PRO_15_16,

    /* 17 Pro Family */
    "iPhone 17 Pro": IMG.BASE_17_PRO,
    "iPhone 17 Pro Max": IMG.BASE_17_PRO
  };

  const norm = (v) => (v || "").toString().trim();

  /* =====================================================
     CHARMS (FROM LIQUID)
     window.CHAOS_BUILDER_DATA.charms = [{name,image,tags,sort_order}, ...]
  ===================================================== */
  const RAW_CHARMS =
    window.CHAOS_BUILDER_DATA && Array.isArray(window.CHAOS_BUILDER_DATA.charms)
      ? window.CHAOS_BUILDER_DATA.charms
      : [];

  const normalizeTags = (tags) => {
    if (Array.isArray(tags)) return tags.map(norm).filter(Boolean);
    if (typeof tags === "string") return tags.split(",").map((s) => norm(s)).filter(Boolean);
    return [];
  };

  const byKey = new Map();
  RAW_CHARMS.forEach((c) => {
    const name = norm(c?.name);
    if (!name) return;

    const key = name.toLowerCase();
    if (byKey.has(key)) return;

    byKey.set(key, {
      name,
      image: norm(c?.image),
      sort_order: Number(c?.sort_order || 0),
      tags: normalizeTags(c?.tags)
    });
  });

  // ✅ make CHARMS mutable so we can inject photo uploads on the photo template
  let CHARMS = [...byKey.values()].sort(
    (a, b) => (Number(b.sort_order || 0) - Number(a.sort_order || 0)) || a.name.localeCompare(b.name)
  );

  /* =====================================================
     DOM HOOKS
  ===================================================== */
  const previewRoot = document.querySelector('[data-cb-root="preview"]');
  const controlsRoot = document.querySelector('[data-cb-root="controls"]');
  if (!previewRoot || !controlsRoot) return;

  const productInfo = previewRoot.closest("product-info") || controlsRoot.closest("product-info");
  const sectionId = productInfo?.getAttribute("data-section") || "no-section";

  // ✅ guard per section
  if (window.__CHAOS_BUILDER_INIT__[sectionId]) return;
  window.__CHAOS_BUILDER_INIT__[sectionId] = true;

  let form = document.getElementById(`product-form-${sectionId}`);
  if (!form) form = document.querySelector('form[action="/cart/add"][id^="product-form-"]');
  if (!form) form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  // IMPORTANT: use the Size dropdown (line item property)
  // ✅ scope to this form (safer; won’t change behavior when only one exists)
  const sizeSelect =
    form.querySelector('select[name="properties[Size]"]') ||
    document.querySelector('select[name="properties[Size]"]');

  const baseImage = previewRoot.querySelector("[data-cb-base-image]");
  const slotEls = [...previewRoot.querySelectorAll("[data-slot]")];

  /* =========================
     SLOT LAYOUTS (DEFAULT + 17 PRO / 17 PRO MAX)
  ========================= */
  const DEFAULT_SLOT_POS = slotEls.map((el) => ({
    top: el.style.top,
    left: el.style.left
  }));

  const SPECIAL_SLOT_MODELS = new Set(["iPhone 17 Pro", "iPhone 17 Pro Max"]);

  const SPECIAL_SLOT_POS = [
    { top: "33.7%", left: "35.7%" }, // slot 1
    { top: "33.7%", left: "49.3%" }, // slot 2
    { top: "33.7%", left: "63.2%" }, // slot 3
    { top: "47.1%", left: "35.7%" }, // slot 4
    { top: "47.1%", left: "49.3%" }, // slot 5
    { top: "47.1%", left: "63.2%" }, // slot 6
    { top: "60.7%", left: "35.7%" }, // slot 7
    { top: "60.7%", left: "49.3%" }, // slot 8
    { top: "60.7%", left: "63.2%" }, // slot 9
    { top: "73.4%", left: "42.5%" }, // slot 10
    { top: "73.3%", left: "57.1%" } // slot 11
  ];

  function applySlotLayoutForModel(model) {
    const m = norm(model);
    const positions = SPECIAL_SLOT_MODELS.has(m) ? SPECIAL_SLOT_POS : DEFAULT_SLOT_POS;
    if (!positions || positions.length !== TOTAL) return;

    slotEls.forEach((el, idx) => {
      const p = positions[idx];
      if (!p) return;
      el.style.top = p.top;
      el.style.left = p.left;
    });
  }

  const picker = controlsRoot.querySelector("[data-cb-picker]");
  const clearBtn = controlsRoot.querySelector("[data-cb-clear]");

  const chipsMount = controlsRoot.querySelector("[data-cb-chips]");
  const metaEl = controlsRoot.querySelector("[data-cb-meta]");
  const hintEl = controlsRoot.querySelector("[data-cc-placehint]");

  // ✅ upload hint lives under the upload section (data-cb-upload-hint)
  const uploadHintEl = controlsRoot.querySelector("[data-cb-upload-hint]");

  // ✅ photo upload hooks (only exist on the photo template)
  const uploadInput = controlsRoot.querySelector("[data-cb-upload]");
  const uploadGrid = controlsRoot.querySelector("[data-cb-upload-grid]");
  const uploadCountEl = controlsRoot.querySelector("[data-cb-upload-count]");
  const isPhotoTemplate = !!uploadInput;

  /* =====================================================
     STATE
  ===================================================== */
  const placedOrder = [];
  const slots = Array(TOTAL + 1).fill(null);
  let draggedCharm = null;
  let armedCharm = null;
  let dragPlaced = null;

  let activeTag = "All";
  let searchTerm = "";

  // ✅ photo uploads state (only used on photo template)
  let UPLOADS = []; // [{name, url, public_id}]

  /* =====================================================
     DRAG HELPERS (placed charms)
  ===================================================== */
  function getClosestSlotFromPoint(clientX, clientY) {
    let best = null;
    let bestDist = Infinity;

    slotEls.forEach((el) => {
      const n = Number(el.dataset.slot);
      if (!n) return;

      const r = el.getBoundingClientRect();
      const cx = r.left + r.width / 2;
      const cy = r.top + r.height / 2;

      const dx = clientX - cx;
      const dy = clientY - cy;
      const dist = Math.sqrt(dx * dx + dy * dy);

      if (dist < bestDist) {
        bestDist = dist;
        best = n;
      }
    });

    return best;
  }

  function clearDropTargets() {
    slotEls.forEach((s) => s.classList.remove("is-drop-target"));
  }

  /* =====================================================
     HELPERS
  ===================================================== */
  // ✅ upload messages no longer write into the charm tip area
  function setHint(text, type = "default") {
    if (type === "upload") {
      if (uploadHintEl) uploadHintEl.textContent = text;
      return;
    }
    if (!hintEl) return;
    hintEl.textContent = text;
  }

  function updateHintForCount() {
    const count = slots.slice(1).filter(Boolean).length;
    if (count < TOTAL) {
      setHint(
        "Tip: Drag a charm onto the case, or select a charm and it will appear in next open slot."
      );
    }
  }

  function clearArmedUI() {
    picker?.querySelectorAll(".cb-charm").forEach((b) => b.classList.remove("is-armed"));
    slotEls.forEach((s) => s.classList.remove("is-armed"));
  }

  function disarm() {
    armedCharm = null;
    clearArmedUI();
  }

  function updateBaseImage() {
    if (!baseImage) return;
    const val = norm(sizeSelect?.value);

    baseImage.crossOrigin = "anonymous";
    baseImage.src = BASES[val] || BASES["iPhone 17"];
  }

  function clearAllCharms() {
    for (let i = 1; i <= TOTAL; i++) slots[i] = null;
    placedOrder.length = 0;
    disarm();
    renderAll();
  }

  function findSlotByCharm(name) {
    const n = norm(name);
    for (let i = 1; i <= TOTAL; i++) {
      if (slots[i]?.name === n) return i;
    }
    return null;
  }

  function nextEmptySlot() {
    for (let i = 1; i <= TOTAL; i++) {
      if (!slots[i]) return i;
    }
    return null;
  }

  function flashSlot(n) {
    const el = slotEls.find((s) => Number(s.dataset.slot) === n);
    if (!el) return;
    el.classList.add("cb-flash");
    setTimeout(() => el.classList.remove("cb-flash"), 500);
  }

  function removeFromOrder(name) {
    const n = norm(name);
    const idx = placedOrder.findIndex((x) => x === n);
    if (idx > -1) placedOrder.splice(idx, 1);
  }

  function touchOrder(name) {
    const n = norm(name);
    const idx = placedOrder.findIndex((x) => x === n);
    if (idx > -1) placedOrder.splice(idx, 1);
    placedOrder.push(n);
  }

  function lastSelectedSlot() {
    const lastName = placedOrder[placedOrder.length - 1];
    if (lastName) {
      const s = findSlotByCharm(lastName);
      if (s) return s;
    }
    for (let i = TOTAL; i >= 1; i--) if (slots[i]) return i;
    return null;
  }

  function placeCharmIntoSlot(slotNum, charm, opts = {}) {
    if (!slotNum || !charm?.name) return;

    const existing = findSlotByCharm(charm.name);
    if (existing && existing !== slotNum) {
      flashSlot(existing);
      return;
    }

    const prev = slots[slotNum];
    if (prev?.name) removeFromOrder(prev.name);

    slots[slotNum] = { name: norm(charm.name), image: charm.image };
    touchOrder(charm.name);

    renderAll();
    flashSlot(slotNum);

    if (opts.replaced && prev?.name) {
      setHint(`Max ${TOTAL} charms — replaced “${prev.name}” with “${charm.name}”.`);
    }
  }

  /* =====================================================
     MODEL CHANGE
  ===================================================== */
  sizeSelect?.addEventListener("change", () => {
    updateBaseImage();
    applySlotLayoutForModel(sizeSelect?.value);
    clearAllCharms();
  });

  updateBaseImage();
  applySlotLayoutForModel(sizeSelect?.value);

  /* =====================================================
     TAGS / FILTER UI
  ===================================================== */
  function getAllTags() {
    const set = new Set();
    CHARMS.forEach((c) => (c.tags || []).forEach((t) => set.add(t)));
    return [...set].filter(Boolean).sort((a, b) => a.localeCompare(b));
  }

  function renderChips() {
    if (!chipsMount) return;

    let tags = getAllTags();

    // ✅ Only show "Custom" tag on photo template once uploads exist
    if (!isPhotoTemplate || !UPLOADS.length) {
      tags = tags.filter((t) => t !== "Custom");
    }

    chipsMount.innerHTML = "";

    const makeChip = (label) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cb-chip" + (activeTag === label ? " is-active" : "");

      // ✅ Rename label for better UX
      if (label === "Custom") {
        btn.textContent = `Your Photos (${UPLOADS.length})`;
      } else {
        btn.textContent = label;
      }

      btn.addEventListener("click", () => {
        activeTag = label;
        renderChips();
        renderPicker();
        renderSelected();
        renderSelectedText();
      });

      return btn;
    };

    chipsMount.appendChild(makeChip("All"));
    tags.forEach((t) => chipsMount.appendChild(makeChip(t)));
  }

  function setMetaText(visibleCount, totalCount) {
    if (!metaEl) return;
    const tagPart = activeTag === "All" ? "All" : activeTag;
    const searchPart = searchTerm ? ` • “${searchTerm}”` : "";
    metaEl.textContent = `${visibleCount}/${totalCount} showing • ${tagPart}${searchPart}`;
  }

  function getFilteredCharms() {
    return CHARMS.filter((ch) => {
      return activeTag === "All" ? true : (ch.tags || []).includes(activeTag);
    });
  }

  /* =====================================================
     PICKER (RIGHT)
  ===================================================== */
  function renderPicker() {
    if (!picker) return;
    picker.innerHTML = "";

    if (!CHARMS.length) {
      picker.innerHTML = `<div style="opacity:.7; font-size:13px;">No charms found. Check your product metafields + controls liquid script.</div>`;
      setMetaText(0, 0);
      return;
    }

    const list = getFilteredCharms();
    setMetaText(list.length, CHARMS.length);

    if (!list.length) {
      picker.innerHTML = `<div style="opacity:.7; font-size:13px;">No matches. Try a different tag.</div>`;
      return;
    }

    list.forEach((ch) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cb-charm";
      btn.dataset.name = ch.name;

      btn.draggable = true;
      btn.addEventListener("dragstart", (e) => {
        draggedCharm = { name: ch.name, image: ch.image };
        e.dataTransfer?.setData("text/plain", ch.name);
        disarm();
      });

      btn.innerHTML = ch.image
        ? `<img src="${ch.image}" alt="${ch.name}" loading="lazy" crossorigin="anonymous">`
        : `<div style="height:60px; display:grid; place-items:center; border:1px dashed rgba(0,0,0,.2); border-radius:10px; width:100%;">No image</div>`;

      btn.addEventListener("click", () => {
        const existing = findSlotByCharm(ch.name);
        if (existing) {
          removeFromOrder(ch.name);
          slots[existing] = null;
          disarm();
          renderAll();
          setHint("Removed. Tap a charm to place it again.");
          return;
        }

        const target = nextEmptySlot();

        if (!target) {
          const replaceSlot = lastSelectedSlot();
          if (!replaceSlot) return;

          placeCharmIntoSlot(replaceSlot, { name: ch.name, image: ch.image }, { replaced: true });
          return;
        }

        placeCharmIntoSlot(target, { name: ch.name, image: ch.image });
      });

      picker.appendChild(btn);
    });

    renderSelected();
  }

  /* =====================================================
     PREVIEW SLOTS (LEFT)
  ===================================================== */
  function renderSlots() {
    slotEls.forEach((el) => {
      const i = Number(el.dataset.slot);
      const data = slots[i];
      el.innerHTML = "";

      el.classList.toggle("is-filled", !!data?.image);

      if (data?.image) {
        const img = document.createElement("img");
        img.crossOrigin = "anonymous";
        img.src = data.image;
        img.alt = data.name;

        img.style.touchAction = "none";

        img.addEventListener("pointerdown", (e) => {
          if (e.pointerType === "mouse" && e.button !== 0) return;

          disarm();
          e.preventDefault();
          e.stopPropagation();

          const fromSlot = i;
          const charm = slots[fromSlot];
          if (!charm) return;

          const r = img.getBoundingClientRect();

          const ghost = document.createElement("img");
          ghost.className = "cb-drag-ghost";
          ghost.src = charm.image;
          ghost.alt = charm.name;

          ghost.style.width = `${r.width}px`;
          ghost.style.height = `${r.height}px`;
          ghost.style.left = `${e.clientX}px`;
          ghost.style.top = `${e.clientY}px`;

          document.body.appendChild(ghost);

          dragPlaced = {
            fromSlot,
            charm,
            ghostEl: ghost,
            pointerId: e.pointerId,
            moved: false
          };

          img.setPointerCapture(e.pointerId);
        });

        img.addEventListener("pointermove", (e) => {
          if (!dragPlaced || dragPlaced.pointerId !== e.pointerId) return;

          dragPlaced.moved = true;
          dragPlaced.ghostEl.style.left = `${e.clientX}px`;
          dragPlaced.ghostEl.style.top = `${e.clientY}px`;

          const target = getClosestSlotFromPoint(e.clientX, e.clientY);
          clearDropTargets();
          if (target) {
            const el2 = slotEls.find((s) => Number(s.dataset.slot) === target);
            el2?.classList.add("is-drop-target");
          }
        });

        const finishPlacedDrag = (e) => {
          if (!dragPlaced || dragPlaced.pointerId !== e.pointerId) return;

          clearDropTargets();

          const { fromSlot, charm, ghostEl } = dragPlaced;
          dragPlaced = null;

          if (ghostEl && ghostEl.parentNode) ghostEl.parentNode.removeChild(ghostEl);

          const toSlot = getClosestSlotFromPoint(e.clientX, e.clientY);

          if (!toSlot || toSlot === fromSlot) {
            renderAll();
            return;
          }

          const toData = slots[toSlot];

          if (!toData) {
            slots[toSlot] = charm;
            slots[fromSlot] = null;
          } else {
            slots[toSlot] = charm;
            slots[fromSlot] = toData;
          }

          touchOrder(charm.name);

          renderAll();
          flashSlot(toSlot);
        };

        img.addEventListener("pointerup", finishPlacedDrag);

        img.addEventListener("pointercancel", (e) => {
          if (!dragPlaced || dragPlaced.pointerId !== e.pointerId) return;
          clearDropTargets();
          dragPlaced.ghostEl?.remove?.();
          dragPlaced = null;
          renderAll();
        });

        el.appendChild(img);

        const x = document.createElement("button");
        x.type = "button";
        x.className = "cb-remove";
        x.setAttribute("aria-label", `Remove ${data.name}`);
        x.innerHTML = "&times;";
        x.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          removeFromOrder(data.name);
          slots[i] = null;
          renderAll();
        });
        el.appendChild(x);
      } else {
        const plus = document.createElement("span");
        plus.className = "cb-plus";
        plus.textContent = "+";
        el.appendChild(plus);
      }
    });
  }

  /* =====================================================
     SLOT INTERACTIONS (BIND ONCE)
  ===================================================== */
  function bindSlotsOnce() {
    slotEls.forEach((el) => {
      if (el.dataset.cbBound === "1") return;
      el.dataset.cbBound = "1";

      el.addEventListener("dragover", (e) => e.preventDefault());

      el.addEventListener("drop", (e) => {
        e.preventDefault();
        const slotNum = Number(el.dataset.slot);
        if (!slotNum || !draggedCharm) return;

        placeCharmIntoSlot(slotNum, draggedCharm);
        draggedCharm = null;
      });

      el.addEventListener("click", (e) => {
        if (e.target.closest(".cb-remove")) return;
        if (dragPlaced) return;

        const slotNum = Number(el.dataset.slot);
        if (!slotNum) return;

        if (armedCharm) {
          placeCharmIntoSlot(slotNum, armedCharm);
          disarm();
          setHint("Placed. Tap another charm or drag more.");
          return;
        }

        if (slots[slotNum]) {
          removeFromOrder(slots[slotNum].name);
          slots[slotNum] = null;
          renderAll();
          setHint("Removed. Tap a charm, then tap a spot.");
        }
      });
    });
  }
  bindSlotsOnce();

  /* =====================================================
     SELECTED HIGHLIGHT + PILLS
  ===================================================== */
  function renderSelected() {
    if (!picker) return;
    [...picker.querySelectorAll(".cb-charm")].forEach((btn) => {
      btn.classList.toggle("is-selected", !!findSlotByCharm(btn.dataset.name));
    });
  }

  function renderSelectedText() {
    const root = controlsRoot.querySelector('[data-cb-selected]');
    if (!root) return;

    const listEl = root.querySelector(".cb-selected-list");
    if (!listEl) return;

    listEl.innerHTML = "";
    const selected = slots.slice(1).filter(Boolean);

    if (!selected.length) {
      const pill = document.createElement("span");
      pill.className = "cb-selected-pill";
      pill.textContent = "None";
      listEl.appendChild(pill);
      return;
    }

    selected.forEach((c) => {
      const pill = document.createElement("span");
      pill.className = "cb-selected-pill";

      const txt = document.createElement("span");
      txt.textContent = c.name;

      const x = document.createElement("button");
      x.type = "button";
      x.setAttribute("aria-label", `Remove ${c.name}`);
      x.innerHTML = "&times;";
      x.addEventListener("click", () => {
        const idx = findSlotByCharm(c.name);
        if (idx) {
          removeFromOrder(c.name);
          slots[idx] = null;
          renderAll();
        }
      });

      pill.appendChild(txt);
      pill.appendChild(x);
      listEl.appendChild(pill);
    });
  }

  /* =====================================================
     PREVIEW IMAGE HELPERS (compose + upload)
  ===================================================== */
  function upsertHiddenProp(name, value) {
    const selector = `input[data-cb-prop="1"][name="properties[${CSS.escape(name)}]"]`;
    let input = form.querySelector(selector);

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${name}]`;
      input.setAttribute("data-cb-prop", "1");
      form.appendChild(input);
    }
    input.value = value || "";
  }

  async function composePreviewBlob() {
    await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

    const rootRect = previewRoot.getBoundingClientRect();
    const dpr = Math.max(1, window.devicePixelRatio || 1);

    const canvas = document.createElement("canvas");
    canvas.width = Math.round(rootRect.width * dpr);
    canvas.height = Math.round(rootRect.height * dpr);

    const ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);

    async function drawImg(imgEl) {
      if (!imgEl) return;

      if (!imgEl.complete) {
        await new Promise((res) => {
          imgEl.onload = res;
          imgEl.onerror = res;
        });
      }

      const r = imgEl.getBoundingClientRect();
      const x = r.left - rootRect.left;
      const y = r.top - rootRect.top;

      try {
        ctx.drawImage(imgEl, x, y, r.width, r.height);
      } catch (e) {}
    }

    await drawImg(baseImage);

    for (const slotEl of slotEls) {
      await drawImg(slotEl.querySelector("img"));
    }

    const blob = await new Promise((res) => canvas.toBlob(res, "image/png", 1));
    return blob;
  }

  async function uploadToCloudinary(blob) {
    const url = `https://api.cloudinary.com/v1_1/${CLOUDINARY.cloudName}/image/upload`;

    const fd = new FormData();
    fd.append("file", blob, `chaos-preview-${Date.now()}.png`);
    fd.append("upload_preset", CLOUDINARY.uploadPreset);
    fd.append("folder", "chaos-previews");

    const resp = await fetch(url, { method: "POST", body: fd });
    const data = await resp.json();

    if (!resp.ok) throw new Error(data?.error?.message || "Cloudinary upload failed");
    return { secure_url: data.secure_url, public_id: data.public_id };
  }

  async function ensurePreviewUploaded() {
    const selected = slots.slice(1).filter(Boolean);
    if (!selected.length) return null;

    const blob = await composePreviewBlob();
    if (!blob) return null;

    const uploaded = await uploadToCloudinary(blob);

    upsertHiddenProp("_Preview image", uploaded.secure_url);
    upsertHiddenProp("_preview_public_id", uploaded.public_id);

    return uploaded;
  }

  /* =====================================================
     PHOTO UPLOADS (ONLY ON PHOTO TEMPLATE)
  ===================================================== */
  function setUploadCount() {
    if (uploadCountEl) uploadCountEl.textContent = String(UPLOADS.length);
  }

  function upsertUploadProps() {
    // Save uploaded URLs to line item properties (admin visibility)
    form.querySelectorAll('input[data-cb-upload-prop="1"]').forEach((el) => el.remove());

    UPLOADS.forEach((u, idx) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[_Photo Charm ${idx + 1}]`;
      input.value = u.url;
      input.setAttribute("data-cb-upload-prop", "1");
      form.appendChild(input);
    });

    const json = document.createElement("input");
    json.type = "hidden";
    json.name = "properties[_Photo Charm URLs]";
    json.value = JSON.stringify(UPLOADS.map((u) => u.url));
    json.setAttribute("data-cb-upload-prop", "1");
    form.appendChild(json);
  }

  function renderUploadGrid() {
    if (!uploadGrid) return;
    uploadGrid.innerHTML = "";

    UPLOADS.forEach((u, idx) => {
      const thumb = document.createElement("div");
      thumb.className = "cb-upload-thumb";

      const img = document.createElement("img");
      img.crossOrigin = "anonymous";
      img.src = u.url;
      img.alt = u.name;

      const rm = document.createElement("button");
      rm.type = "button";
      rm.className = "cb-upload-remove";
      rm.innerHTML = "&times;";
      rm.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        UPLOADS.splice(idx, 1);

        const key = (u.name || "").toLowerCase();
        CHARMS = CHARMS.filter((c) => (c.name || "").toLowerCase() !== key);

        for (let i = 1; i <= TOTAL; i++) {
          if ((slots[i]?.name || "").toLowerCase() === key) {
            slots[i] = null;
          }
        }

        if (activeTag === "Custom" && UPLOADS.length === 0) activeTag = "All";

        setUploadCount();
        upsertUploadProps();
        renderChips();
        renderPicker();
        renderAll();
        renderUploadGrid();
      });

      thumb.appendChild(img);
      thumb.appendChild(rm);
      uploadGrid.appendChild(thumb);
    });
  }

  async function uploadFileToCloudinary(file) {
    const url = `https://api.cloudinary.com/v1_1/${CLOUDINARY.cloudName}/image/upload`;
    const fd = new FormData();
    fd.append("file", file);
    fd.append("upload_preset", CLOUDINARY.uploadPreset);
    fd.append("folder", "chaos-photo-charms");

    const resp = await fetch(url, { method: "POST", body: fd });
    const data = await resp.json();
    if (!resp.ok) throw new Error(data?.error?.message || "Photo upload failed");
    return { secure_url: data.secure_url, public_id: data.public_id };
  }

  async function handlePhotoUpload(fileList) {
    const files = [...fileList];
    if (!files.length) return;

    const remaining = TOTAL - UPLOADS.length;
    const batch = files.slice(0, Math.max(0, remaining));
    if (!batch.length) return;

    for (const file of batch) {
      const uploaded = await uploadFileToCloudinary(file);

      const name = `Custom Photo ${Date.now()}-${Math.floor(Math.random() * 1000)}`;

      UPLOADS.push({
        name,
        url: uploaded.secure_url,
        public_id: uploaded.public_id
      });

      CHARMS.push({
        name,
        image: uploaded.secure_url,
        tags: ["Custom"],
        sort_order: -1000
      });

      // ✅ auto-place into next empty slot (if any)
      const open = nextEmptySlot();
      if (open) {
        slots[open] = { name: norm(name), image: uploaded.secure_url };
        touchOrder(name);
      }
    }

    // de-dupe & sort
    const seen = new Set();
    CHARMS = CHARMS
      .filter((c) => {
        const k = (c.name || "").toLowerCase();
        if (!k || seen.has(k)) return false;
        seen.add(k);
        return true;
      })
      .sort((a, b) => (Number(b.sort_order || 0) - Number(a.sort_order || 0)) || a.name.localeCompare(b.name));

    setUploadCount();
    upsertUploadProps();
    renderUploadGrid();

    // ✅ IMPORTANT: do NOT force "Custom" tab — keep whatever user had (defaults to All)
    renderChips();
    renderPicker();
    renderAll();
  }

  if (isPhotoTemplate) {
    setUploadCount();
    renderUploadGrid();

    uploadInput.addEventListener("change", async (e) => {
      const files = e.target.files;
      if (!files?.length) return;

      try {
        // upload messages go to upload hint area only
        setHint("Uploading your photos", "upload");
        uploadHintEl?.classList.add("loading");

        await handlePhotoUpload(files);

        // stop the dots, then show success
        uploadHintEl?.classList.remove("loading");
        setHint("Uploaded! Your photos are now available in Your Photos.", "upload");

        // clear success message after 2.5s
        setTimeout(() => {
          if (uploadHintEl) uploadHintEl.textContent = "";
        }, 2500);
      } catch (err) {
        console.error(err);
        alert("Upload failed — please try again.");

        uploadHintEl?.classList.remove("loading");
        setHint("Upload failed — please try again.", "upload");

        // optional: clear error message after a bit too
        setTimeout(() => {
          if (uploadHintEl) uploadHintEl.textContent = "";
        }, 3500);
      } finally {
        uploadInput.value = "";
      }
    });
  }

  /* =====================================================
     LINE ITEM PROPERTIES
  ===================================================== */
  function renderProps() {
    try {
      if (!form) return;

      const existingPreviewUrl =
        form.querySelector('input[name="properties[_Preview image]"]')?.value || "";
      const existingPreviewId =
        form.querySelector('input[name="properties[_preview_public_id]"]')?.value || "";

      form.querySelectorAll('[data-cb-prop="1"]').forEach((el) => el.remove());

      for (let i = 1; i <= TOTAL; i++) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `properties[_Charm ${i}]`;
        input.value = slots[i]?.name || "";
        input.setAttribute("data-cb-prop", "1");
        form.appendChild(input);
      }

      const selected = slots.slice(1).filter(Boolean).map((c) => c.name);
      const selectedInput = document.createElement("input");
      selectedInput.type = "hidden";
      selectedInput.name = "properties[Selected charms]";
      selectedInput.value = selected.join(", ");
      selectedInput.setAttribute("data-cb-prop", "1");
      form.appendChild(selectedInput);

      const layout = slots.slice(1).map((c, idx) => ({
        slot: idx + 1,
        name: c?.name || null
      }));

      const json = document.createElement("input");
      json.type = "hidden";
      json.name = "properties[_Charm Layout]";
      json.value = JSON.stringify(layout);
      json.setAttribute("data-cb-prop", "1");
      form.appendChild(json);

      if (existingPreviewUrl) upsertHiddenProp("_Preview image", existingPreviewUrl);
      if (existingPreviewId) upsertHiddenProp("_preview_public_id", existingPreviewId);

      // ✅ keep upload props (if photo template)
      if (isPhotoTemplate && UPLOADS.length) upsertUploadProps();
    } catch (err) {
      console.error("[CHAOS BUILDER] renderProps error:", err);
    }
  }

  /* =====================================================
     MASTER RENDER
  ===================================================== */
  function renderAll() {
    renderSlots();
    renderSelected();
    renderSelectedText();
    renderProps();
    updateHintForCount();
  }

  /* =====================================================
     EVENTS
  ===================================================== */
  clearBtn?.addEventListener("click", () => {
    clearAllCharms();
  });

  let __cbSubmitting = false;
  let __cbBypass = false;

  form.addEventListener(
    "submit",
    async (e) => {
      if (__cbBypass) {
        __cbBypass = false;
        return;
      }

      if (__cbSubmitting) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      renderProps();

      const selected = slots.slice(1).filter(Boolean);
      if (!selected.length) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      __cbSubmitting = true;

      try {
        await ensurePreviewUploaded();
        renderProps();

        __cbBypass = true;
        __cbSubmitting = false;

        form.requestSubmit();
      } catch (err) {
        console.error(err);
        alert("Preview upload failed — please try again.");
        __cbSubmitting = false;
        __cbBypass = false;
      }
    },
    true
  );

  /* =====================================================
     INIT
  ===================================================== */
  renderChips();
  renderPicker();
  renderAll();
})();